export default function MinusIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M18 13H6V11H18V13Z" fill="#3C3C3C" />
    </svg>
  );
}
